import { render } from "./EarnTipsDialog.vue?vue&type=template&id=b8b3859e&scoped=true"
import script from "./EarnTipsDialog.vue?vue&type=script&lang=js"
export * from "./EarnTipsDialog.vue?vue&type=script&lang=js"

import "./EarnTipsDialog.vue?vue&type=style&index=0&id=b8b3859e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b3859e"]])

export default __exports__